import { useEffect, useRef, useState } from 'react';
import { fieldType } from 'src/types/form';
import { TGDisclosure } from '../../TGDisclosure';
import { SubResetFilter } from 'src/pages/DashboardPage/mytasks/meetingsPage/components/MeetingCard';
import { FlexCol } from 'src/utils/flexLayouts';

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    value: string | null;
    errors?: any;
    type: string;
};

function NumberRange(props: Props) {
    const { dataField, onChange, value, errors, type } = props;
    const [numberFrom, setNumberFrom] = useState('');
    const [numberBefore, setNumberBefore] = useState("");
    const [errorNumber, setErrorNumber] = useState("");

    useEffect(() => {
        if (dataField.default) {
            setNumberFrom(dataField.default.numberFrom)
            setNumberBefore(dataField.default.numberBefore)
        }
    }, [dataField]);

    useEffect(() => {
        if (!value) {
            setNumberFrom('');
            setNumberBefore('');
        }
    }, [value])

    const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
        if (type === 'from') {
            setNumberFrom(event.target.value);
        } else {
            setNumberBefore(event.target.value);
        }
    };

    useEffect(() => {
        if (numberFrom && numberBefore) {
            if (Number(numberBefore) > Number(numberFrom)) {
                setErrorNumber("");
                onChange({ fromNumber: Number(numberFrom), beforeNumber: Number(numberBefore) })
            } else {
                setErrorNumber("Проверьте корректность данных. Число от, должно быть меньше числа до");
            }
        } else {
            setErrorNumber("Обязательно заполнение всех данных");
        }
    }, [numberFrom, numberBefore]);

    return (

        <TGDisclosure disabled={dataField.disabled} wrapperClassName={dataField.width} title={dataField.title} count={value && 1 || 0}>
            <div className={`${dataField.width} mb-5`}>
                {/* <label className='flex flex-row justify-between text-sm font-medium leading-6 text-gray-900'>
                    <span>{dataField.title}</span>
                    {dataField.require && (
                        <div className='flex flex-row justify-between'>
                            {Object.keys(errors).length > 0 && errors[dataField.key] && <span className='text-[#BA0C2F]'>Заполните поле&nbsp;</span>}
                            <span className='text-[#BA0C2F]'>*</span>
                        </div>
                    )}
                </label> */}
                <FlexCol className='mt-2 relative cursor-pointer gap-2'>
                    <span>От</span>
                    <input
                        type='number'
                        className='text-left block w-full text-base rounded-lg border border-[#DFE4EA] py-3 px-5 text-black outline-none disabled:text-[#6B7280] disabled:bg-[#E5E7EB] cursor-pointer'
                        value={numberFrom}
                        onChange={(e) => handleNumberChange(e, 'from')}
                        disabled={dataField.disabled}
                        placeholder={dataField.placeholder}
                    />
                </FlexCol>
                <FlexCol className='mt-2 relative cursor-pointer gap-2'>
                    <span>До</span>
                    <input
                        type='number'
                        className='text-left block w-full text-base rounded-lg border border-[#DFE4EA] py-3 px-5 text-black outline-none disabled:text-[#6B7280] disabled:bg-[#E5E7EB] cursor-pointer'
                        value={numberBefore}
                        onChange={(e) => handleNumberChange(e, 'before')}
                        disabled={dataField.disabled}
                        placeholder={dataField.placeholder}
                    />
                </FlexCol>
                <FlexCol className='mt-2'>{errorNumber}</FlexCol>
            </div>
            <SubResetFilter resetFilter={() => {
                setNumberFrom('');
                setNumberBefore('');
                onChange(null);
            }} />
        </TGDisclosure>

    );
}

export default NumberRange;
